module.exports = __webpack_public_path__ + "img/sunset.8d1393f5.jpg";